import { useTrackingEvents } from '~/composables/tracking-events/use-tracking-events'
import { useUserStore } from '#lib/stores'
import { TrackingEventName, CriteriaWeights } from '~/enums'

export function useUserEngagementEvents() {
  const { trackingEvents } = useTrackingEvents()
  const userStore = useUserStore()
  const { user } = useUser()
  const { fetchUserBanks, userBanks } = useUserBank()


  const profileCompletionPercentage = computed(() => {
    const criteria = [
      {
        key: 'Email',
        condition: !!user.value.email,
        weight: CriteriaWeights.Email,
      },
      {
        key: 'OwnerBanks',
        condition: !!userBanks.value.length,
        weight: CriteriaWeights.OwnerBanks,
      },
    ]
    let totalWeight = 0
    let achievedWeight = 0

    // Loop through criteria to sum weights
    criteria.forEach(({ condition, weight }) => {
      totalWeight += weight
      if (condition) {
        achievedWeight += weight
      }
    })

    return totalWeight > 0 ? achievedWeight / totalWeight : 0
  })

  const trackingProfileCompletion = async (): Promise<void> => {
    await fetchUserBanks()
    const params = {
      user_id: userStore.data.id,
      profile_completion_percentage: profileCompletionPercentage.value * 100,
    }
    trackingEvents(TrackingEventName.ProfileCompletion, params)
  }

  const trackingWhenAddBankCompletion = () => {
    const params = {
      user_id: userStore.data.id,
      profile_completion_percentage: profileCompletionPercentage.value * 100,
    }
    trackingEvents(TrackingEventName.ProfileCompletion, params)
  }

  const trackingLogin = () => {
    const userId = userStore.data.id
    const gaValue = useCookie('_ga').value as string

    const params = {
      user_id: userId || gaValue,
    }
    trackingEvents(TrackingEventName.Login, params)
  }

  return {
    trackingProfileCompletion,
    trackingLogin,
    trackingWhenAddBankCompletion
  }
}
